'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.f = exports.AtpFunction = exports.DelayedEvent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _object = require('./object');

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Convenience wrapper around setTimeout
 * @class DelayedEvent
 * @param {Function} callback - the function to delay
 * @example f(func).delay().for(5).seconds();
 */
var DelayedEvent = exports.DelayedEvent = function () {
    function DelayedEvent(callback) {
        _classCallCheck(this, DelayedEvent);

        this.callback = callback;
        this.event = null;
        this.delay = 0;
    }

    /**
     * Cancel the delayed function.  Note that the DelayedEvent can be re-queued by calling runIn() again.
     * @returns {DelayedEvent}
     */


    _createClass(DelayedEvent, [{
        key: 'cancel',
        value: function cancel() {
            clearTimeout(this.event);
            return this;
        }

        /**
         * Synonym for runIn, useful in fluent expressions
         * @param {Number} delay - The time to delay the function's execution, modifiable with subsequent interval calls
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).seconds();
         */

    }, {
        key: 'for',
        value: function _for(delay) {
            return this.runIn(delay);
        }

        /**
         * Set (or reset) the delay of the function
         * @param {Number} delay - The time to delay the function's execution, modifiable with subsequent interval calls
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).seconds();
         */

    }, {
        key: 'runIn',
        value: function runIn(delay) {
            return this._runIn(delay, true);
        }
    }, {
        key: '_runIn',
        value: function _runIn(delay) {
            var save = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (save) this.delay = delay;
            this.cancel();
            this.event = setTimeout(this.callback, delay);
            return this;
        }

        /**
         * Interpret the previously specified delay as a delay in milliseconds
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).milliseconds();
         */

    }, {
        key: 'milliseconds',
        value: function milliseconds() {
            return this;
        }

        /**
         * Interpret the previously specified delay as a delay in seconds
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).seconds();
         */

    }, {
        key: 'seconds',
        value: function seconds() {
            this._runIn(this.delay * 1000, false);return this;
        }

        /**
         * Interpret the previously specified delay as a delay in minutes
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).minutes();
         */

    }, {
        key: 'minutes',
        value: function minutes() {
            this._runIn(this.delay * 60 * 1000, false);return this;
        }

        /**
         * Interpret the previously specified delay as a delay in hours
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).hours();
         */

    }, {
        key: 'hours',
        value: function hours() {
            this._runIn(this.delay * 60 * 60 * 1000, false);return this;
        }

        /**
         * Interpret the previously specified delay as a delay in days
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).days();
         */

    }, {
        key: 'days',
        value: function days() {
            this._runIn(this.delay * 24 * 60 * 60 * 1000, false);return this;
        }
    }]);

    return DelayedEvent;
}();
/**
 * A wrapper for convenient functions related to functions
 *
 * @class ATPFunction
 */


var AtpFunction = exports.AtpFunction = function (_AtpObject) {
    _inherits(AtpFunction, _AtpObject);

    function AtpFunction() {
        _classCallCheck(this, AtpFunction);

        return _possibleConstructorReturn(this, (AtpFunction.__proto__ || Object.getPrototypeOf(AtpFunction)).apply(this, arguments));
    }

    _createClass(AtpFunction, [{
        key: 'delay',

        /**
         * Convenience method for setTimeout() allowing for a more fluid style
         * @returns {DelayedEvent}
         * @example f(func).delay().for(5).seconds();
         */
        value: function delay() {
            return new DelayedEvent(this.raw);
        }
    }]);

    return AtpFunction;
}(_object.AtpObject);

/**
 * Wrap the specified function in an ATPFunction object
 *
 * @param {Function} func
 */


var f = exports.f = function f(func) {
    return func instanceof AtpFunction ? func : new AtpFunction(func);
};